module.exports = __webpack_public_path__ + "static/img/RAPU-A_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPU-A_1.png
// module id = 3Kh6
// module chunks = 0